import "aos/dist/aos.css";
import { useEffect, useState, useRef } from "react";
import Header from "./dashboard/header";
import getContract, { getIpToken } from "../services/contract";
import { ethers } from "ethers";
import { FaRocket } from "react-icons/fa";
import { IoMdSwap } from "react-icons/io";
import { FaMoneyCheckDollar } from "react-icons/fa6";
import { FaClipboardList } from "react-icons/fa";
import { FaFlagCheckered } from "react-icons/fa";
import { MdGeneratingTokens } from "react-icons/md";
import { FaUserLock } from "react-icons/fa";
import { FaUsers } from "react-icons/fa";
import Footer from "./footer";
import AOS from "aos";
import { TransactionService } from '../services/transactionService'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import getWallet, { disconnectWallet, onChange } from '../services/wallet';
import getTokenContract from '../services/tokenContract';
import { useNavigate, useLocation } from "react-router-dom";
import queryString from 'query-string';
import {
  AiFillAccountBook,
  AiFillCopy,
  AiOutlinePaperClip,
  AiOutlineShareAlt,
} from "react-icons/ai";

const Home = (props) => {
  const navigate = useNavigate();
    const location = useLocation(); 
  
    const isFirstRender = useRef(true);
  
    let [signer, setSigner] = useState(null);
    let [ip, setIp] = useState('');
    let [loginId, setLoginId] = useState('');
    let [referrerId, setReferrerId] = useState(1);
    let [isConnected, setIsConnected] = useState(0);
    let [balance, setBalance] = useState(0);
    let [userAddress, setUserAddress] = useState('');
    let [usdtAddress, setUsdtAddress] = useState('');
  
    let [totalValue, setTotalValue] = useState(0);
    let [totalValueIp, setIpTotalValue] = useState(0);
    let [totalMembers, setTotalMembers] = useState(0);
  
    const [activeIndex, setActiveIndex] = useState(null);
  
    const notify = (message) => toast(message);
  
    const handleConnectWallet = async () => {
      await connectWallet();
    };
  
    const handleDisconnect = async () => {
      setBalance(0);
      setSigner(null);
      setUserAddress('');
      setIsConnected(false);
      disconnectWallet();
    }
    
    const toggleAccordion = (index) => {
      setActiveIndex(activeIndex === index ? null : index);
    };
  
    useEffect(() => {
      connectWallet();
    }, []);
  
    useEffect(() => {
      AOS.init({ duration: 1500 });
      async function getData() {
        try {
          
          const contract = await getContract();
          const lastIdCount = await contract.lastIDCount()
          setTotalMembers(
            ethers.BigNumber.from(lastIdCount).toNumber()
          );
          
          const valueInvestedBN = await contract.totalValueInvested();
          
          const totalInvested = +ethers.utils.formatUnits(
            valueInvestedBN,
            "mwei"
          );
          
          setTotalValue(totalInvested);
          
          const token = await getTokenContract();
          setUsdtAddress(token.address);
          
          // await getBalance();
  
        } catch (error) {
          console.log(error);
        }
      }
      getData();
    }, []);
  
    useEffect(() => {
      if (location.search) {
          const { refid } = queryString.parse(location.search); // Parse URL query params
          console.log(refid);
          
          if (refid) {
              setReferrerId(refid); // Update state with refId from URL
          }
      }
    }, [location.search])
  
    useEffect(() => {
      if(!signer) return
      getBalance();
      
    } , [signer]);
  
    const addToMetamask = async () => {
      try {
        // wasAdded is a boolean. Like any RPC method, an error may be thrown.
        const wasAdded = await window.ethereum.request({
          method: 'wallet_watchAsset',
          params: {
            type: 'ERC20', // Initially only supports ERC20, but eventually more!
            options: {
              address: usdtAddress, // The address that the token is at.
              // address: '0xD6bdfA86136F8390C8513d27C2578fE7e54C89d8', // The address that the token is at.
              symbol: 'USDT', // A ticker symbol or shorthand, up to 5 chars.
              decimals: 6, // The number of decimals in the token
            },
          },
        });
  
        if (wasAdded) {
          console.log('Thanks for your interest!');
        } else {
          console.log('Your loss!');
        }
      } catch (error) {
        console.log(error);
      }
    }
  
    const connectWallet = async () => {
      const wallet = await getWallet();
      if (!wallet.isReadOnly) {
        // if(wallet.isWrongNetwork) {
        //     throw new Error('Switch to Polygon');
        //     return;
        // }
  
        const browserAddresses = await wallet.provider.listAccounts();
        
        setUserAddress(browserAddresses[0]);
        setIsConnected(true);
        setSigner(wallet.signer);
  
      } else {
        // throw new Error('Wallet not connected');
      }
    }
  
    const getBalance = async () => {
      const token = await getTokenContract();
      
      const balance = await token.balanceOf(userAddress);
      if(balance.gt(ethers.BigNumber.from("0"))) {
          const totalBalanceBN = balance.div(ethers.BigNumber.from("1000000"));
          const totalBalance = ethers.BigNumber.from(totalBalanceBN).toString();
          setBalance(totalBalance);
  
      }
    }
  
    const handleRegister = async () => {
      const wallet = await getWallet();
      if (!isConnected) {
        alert('Connect wallet');
        return;
      }
      try {
        var transactionService = new TransactionService(0, userAddress);
        const registrationPromise = transactionService.register(referrerId);
        const newId = await toast.promise(
          registrationPromise,
          {
            pending: `Joining in process under ID: ${referrerId}`,
            success: 'Joining Successfull',
            error: 'Joining failed'
          },
          {
            position: toast.POSITION.BOTTOM_CENTER 
          }
        )
        console.log(newId);
        
        if (newId > 0) { 
          navigate('/dashboard/' + newId);
        }
      } catch (error) {
        console.log(error);
        alert(error.message);
      }
    } 
  
    const handleViewClick = async () => {
      const contract = await getContract();
      const id = loginId;
      const lastId = ethers.BigNumber.from(
        await contract.lastIDCount()
      ).toNumber();
      if (lastId < id || id < 1) {
        alert(`User Id ${id} not found`);
        return;
      }
      // this.props.router.navigate("/dashboard/" + id);
      navigate("/dashboard/" + id);
    }
  
    const handleLogin = async () => {
      const wallet = await getWallet();
      if (!wallet.isReadOnly) {
        const browserAddresses = await wallet.provider.listAccounts();
        const contract = await getContract();
        const id = ethers.BigNumber.from(
          await contract.getIdByAddress(browserAddresses[0])
        ).toNumber();
        if (id == 0) {
          alert(
            "No id found with your connected wallet make sure switch to joined account on metamask"
          );
          return;
        }
        navigate("/dashboard/" + id);
      }
    };
  
    const accordions = [
      {
        id: 0,
        title: "What is easyflowpro.com?",
        body: "easyflowpro.com is the international community of the global decentralized ecosystem and the first ever smart contract marketing matrix of the Polygon networks. This is a self-executing software algorithm that performs the function of distributing partner rewards between community members, subject to certain conditions (matrix marketing plan). The contract code is publicly available. Information about transactions in the Polygon network can always be viewed at the link https://polygonscan.com"
      },
      {
        id: 1,
        title: "Who manages the platform?",
        body: "The easyflowpro.com platform consists of self-executing trades, which do not permit anyone to interfere with the course of the transactions."
      },
      {
        id: 2,
        title: "Who created easyflowpro.com?",
        body: "The easyflowpro.com concept belongs to a group of crypto enthusiasts, who are members of the community and don't have any special privileges. Today, easyflowpro.com is a peer-to-peer community of platform members, to whom the platform itself belongs."
      },
      {
        id: 3,
        title: "What is a smart contract? What are its advantages?",
        body: "A smart contract is an algorithm within a cryptocurrency's blockchain. In our case, USDT similar to US Dollar on Polygon chain is our first choice among those on which it is possible to create smart contracts. The main purpose of such contracts is the automation of the relationship, the opportunity to make a commitment self-executing."
      },
      {
        id: 4,
        title: "What is decentralization?",
        body: "The process works based on distributing authority from a centralized administration to the participants involved in the process. Unlike a centralized system, all decisions are made by consensus."
      },
      {
        id: 5,
        title: "What do I need to do in order to join the community?",
        body: "To join the community, you need to install on your device (smartphone, tablet, PC) a crypto wallet and Telegram messenger and join at https://t.me/sxm2023"
      },
      {
        id: 6,
        title: "Which wallet should I use?",
        body: "easyflowpro.com works with all crypto wallets. When working with easyflowpro.com: - for all types of EVM wallets like Metamask and Trust Wallet. These wallets are among the most popular and demanded in the global crypto industry."
      },
      {
        id: 7,
        title: "Where can I get more information about easyflowpro.com?",
        body: "We recommend subscribing to verified easyflowpro.com Telegram channels. There you can ask questions to participants who will be happy to share their experiences. Join the Telegram chat."
      },
      {
        id: 8,
        title: "How to buy / sell USDT if I have never dealt with cryptocurrency?",
        body: "There are many ways to buy / sell cryptocurrency for fiat money (currencies we are used to). All of them are designed for ordinary users and have an intuitive interface. The first operation will take you no more than 5 minutes on the site for exchanging fiat money for digital money."
      },
      {
        id: 9,
        title: "How can I register on the easyflowpro.com platform?",
        body: "To register with easyflowpro.com, you need to switch to Polygon chain and send 20 USDT (Tether) to a smart contract to activate your account in platform. Please note: when replenishing a crypto wallet, it is important to take into account to get the commission in the Polygon network."
      },
      {
        id: 10,
        title: "Can I register on the website without a partner link?",
        body: "Yes. Registration without an invitation link will put you in the id 1 team."
      },
      {
        id: 11,
        title: "What will happen to my account if I take a break from working with the easyflowpro.com community?",
        body: "No one can close your account, even if they have a strong desire to do so. The account will always be saved in one of the Polygon chain blocks. You will continue to receive income from all levels."
      },
      {
        id: 12,
        title: "I have activated the platform, what should I do next?",
        body: "To effectively interact with the easyflowpro.com platform, you need: Talk to the person who invited you or other experienced participants - they will help you take the first steps. And then go to 'Community' for learning more so that you will get successful work on the platform."
      },
      {
        id: 13,
        title: "How can I reach my goals with easyflowpro.com?",
        body: "It is based on building a partner network. You tell potential partners about the platform's potential and encourage them to collaborate with you. Partners who use your link send their first transactions to the smart contract address, and these are then instantly redirected to your wallet. Read more about the marketing plans in the presentations."
      },
      {
        id: 14,
        title: "Is passive income possible?",
        body: "The platforms easyflowpro.com is designed in such a way that all participants in the system help each other. Passive income is possible, it depends on the activity of partners who can get into your sites through overflows or overtaking. You can receive spillovers from upstream or downstream partners, but your income will depend on their activity. To provide yourself with passive income in the future, you need to make certain efforts - to attract new partners and open new platforms in by inviting even one very active person to your team, you can already earn money and achieve your goals. How quickly this happens is up to you."
      },
      {
        id: 15,
        title: "How can I attract people effectively? What should I do if I can’t attract anyone?",
        body: "You don't have to force participation on anyone. Now many people are interested in making money on the Internet, and some are looking for new opportunities themselves. You can find them on social networks on your own, or set up an automatic sales funnel and interested people will find you themselves. More about this in the 'Community'. Use your strengths, watch webinars, ask questions to experienced platform members and improve your skills through free schooling and success will not keep you waiting. Your result depends only on you! Use guide."
      },
      {
        id: 16,
        title: "Do I need to withdraw money from smart contract?",
        body: "easyflowpro.com does not retain any funds, so the balance of the smart contract is equal to zero. You can see this for yourself, by following the LINK. Your income arrives instantly into your personal wallet directly from your partners. Only you have access to your wallet and no one else can manage your money."
      },
      {
        id: 17,
        title: "What are program, and what are levels?",
        body: "The programs are matrices with a limited number of places. There are places in the programs. When filling in the matrix, the same new one opens automatically. Each program has 2 levels in easyflowpro.com. Each level costs by designed plan more expensive than the previous one and allows you to earn more."
      },
      {
        id: 18,
        title: "Do levels have a validity period?",
        body: "Not. You buy any level in the program once and for all. Levels have no expiration dates. This makes the platform significantly different from other platforms where repeat payments are required from you."
      },
      {
        id: 19,
        title: "What is Repeat (Re-opening)?",
        body: "If there are no free places left on a level, then the next partner gets a place in an automatically created matrix of the same level. This is called Repeat. The partner who took the last place pays for the new matrix, and the amount goes to a higher-ranked partner. This process is entirely automated by the smart contract."
      },
      {
        id: 20,
        title: "What are 'overflows' and 'overtakes'?",
        body: "Overflows are when vacant places in your sites are filled with partners who were not invited by you. They can come from both an upstream partner and a downstream partner. Overtaking is a situation when your partner does not have a level that his partner activates and the transaction is sent along the chain to you, provided that you have this level active. This partner follows you and brings you income until his superior partner activates the missing levels."
      },
      {
        id: 21,
        title: "Can I lose partner whom I have personally invited?",
        body: "No. This is out of the question. Your personally invited partner stays with you forever thanks to the referral link."
      },
      {
        id: 22,
        title: "How does this differ from a pyramid scheme?",
        body: "easyflowpro.com doesn't give members unfulfilled promises like a pyramid scheme. Everyone's success depends on himself. easyflowpro.com is stable even at 1000x scaling. easyflowpro.com does not create debt or other obligations. easyflowpro.com is a next generation crowdfunding platform and has nothing to do with pyramids. The principle of a pyramid scheme is based on the fact that most of the money is concentrated in the hands of its creators. The earlier you came, the more you earned. The financial pyramid can close at any time. Members of the easyflowpro.com platform - both leaders and newcomers - are on an equal footing. Nobody can stop the work of the platform. its functioning is provided by a smart contract, which cannot be deleted or changed. Even if the site stops working, all data and structure will be intact, and the smart contract will continue to function as long as the Internet and electricity exist."
      },
      {
        id: 23,
        title: "What are the risks?",
        body: "There are no risks to the easyflowpro.com platform. It is enough to invite 1 person to immediately recoup the initial participation costs. The platform operates on the basis of a smart contract in the blockchain system. The smart contract code is publicly available. All transfers go directly to your personal wallet, without any hidden fees and without the use of third-party resources. This ensures that any amount you earn belongs to you and only you, and you can use the money in any way you want in the very second it entered your wallet."
      }
    ];

  return (
    <div id="home">
      <ToastContainer
        position="bottom-center"
        theme="colored"
        autoClose={10000}
        style={{ zIndex: 1 }}
      /> <ToastContainer />

      <Header
        isHome={true}
        userAddress={userAddress}
        onConnectWallet={handleConnectWallet}
        signer={signer}
        onDisconnect={handleDisconnect}
      />
      <section
        className="banner"
        style={{ backgroundImage: "url(/logo/b23.jpg)" }}
      >
        <div className="banner-sections">
          <div className="logo-sec" data-aos="fade-right">
            <img
              src="/logo/Logo2.png"
              style={{ width: "400px", margin: "0 auto" }}
            />
          </div>
          <div className="content-sec" data-aos="fade-left">
            {/* <p>
            “Easyflow” aspires to be a leading decentralized platform, guided by five core principles:
            Transparency: All transactions and operations are verifiable on the blockchain.
            Simplicity: Designed for ease of use, accommodating members of all experience levels.
            Speed: Immediate income generation through automated mechanisms.
            Sustainability: A robust structure built for long-term growth.
            Fairness: Equitable distribution of benefits to all members.
            <br/>
            “Easyflow” is built upon five fundamental principles to ensure it meets the needs of its users:
            User-Friendly, Transparent, Verifiable, and Fair System: Leveraging Polygon’s decentralized blockchain technology, members can trust in the transparency and accuracy of all operations.
            Marketing Plan for Rapid and Sustainable Income: A mechanism designed to deliver immediate returns while ensuring long-term stability.
            Automated Organizational Growth: Simplifies team expansion through fully automated processes.
            Automation for Maximum Growth: Supports every member’s business to reach its full potential.
            Rewards and Incentives: Provides rewards to high-performing members, encouraging participation and success.
              </p> */}
            <video width="1100" height="340" controls>
              <source src="/presentation.mp4" type="video/mp4" />
              {/* <source src="movie.ogg" type="video/ogg" /> */}
              Your browser does not support the video tag.
            </video>
          </div>
        </div>
      </section>
      <section className="custom-container authentication-section grid grid-cols-2 sm:grid-cols-1">
        <div className="grid grid-cols-1">
          <div className="info-card">
              <div className="heading">
                <h4>How to Register</h4>
              </div>
              <p>
                Access the website via Metamask mobile app or use browser
                extension. For Mobile users use Trust wallet app or Tocken Pocket
                (TP) for choices
              </p>
              <div className="heading">
                <h4>How To Access Dashboard</h4>
              </div>
              <p>
                You'll automatically navigate to Dashboard after joining OR Access
                Your Dashboard Via Homepage Login Button
              </p>
            </div>
        </div>
        <div className="grid grid-cols-1">
          <div className="login" data-aos="fade-right">
            <h3>Login</h3>
            <input onChange={(e) =>  setLoginId(e.target.value) } value={loginId} id="idbyPlan" type="number" placeholder="Enter Id" />
            <div className="actions">
              <button onClick={handleViewClick} className="button lightBtn">View</button>
              <button onClick={handleLogin} className="button whiteBtn">Login</button>
            </div>
          </div>
          <div className="register-form" data-aos="fade-left">
              <h3>Register</h3>
              <div className="requireAmount">
                <span>Upline ID</span>
              </div>
              <input onChange={(e) => setReferrerId(e.target.value) } value={referrerId} id="idbyPlan" type="number" placeholder="Enter Upline Id" />
              <div className="requireAmount">
                <i className="las la-info-circle text-3xl text-base"></i>
                <span>Requires 5 USDT</span>
              </div>
              <span className="balance">USDT balance: {balance} </span>
              <div className="actions">
                <button onClick={handleRegister} className="button whiteBtn">Register</button>
                <button onClick={addToMetamask} className="button lightBtn">Add USDT To Wallet</button>
              </div>
            </div>
            
        </div>
      </section>
      <div
        className="grid grid-cols-4 dashboard-copy-grid items-center mb-5"
        style={{ gap: "10px" }}
      >
        <div className="col-span-2 grid-left text-center">
          
          <div
            className="grid grid-cols-2"
            style={{ gap: "10px", marginTop: "10px" }}
          >
            <div
              className="border p-5 rounded-md efcard"
            >
              <h3
                style={{
                  fontSize: "18px",
                  marginBottom: "10px",
                  fontWeight: "bold",
                }}
              >
                Total Members
              </h3>
              <div className=" text-center">
                <h2 style={{ fontSize: "18px" }}>{totalMembers}</h2>
                {/* <AiFillAccountBook style={{ fontSize: "30px" }} /> */}
              </div>
            </div>
            <div
              className="border p-5 rounded-md efcard"
            >
              <h3
                style={{
                  fontSize: "18px",
                  marginBottom: "10px",
                  fontWeight: "bold",
                }}
              >
                Total USDT
              </h3>
              <div className=" text-center">
                <h2 style={{ fontSize: "18px" }}>{totalValue}</h2>
                {/* <AiFillAccountBook style={{ fontSize: "30px" }} /> */}
              </div>
            </div>
          </div>
        </div>
      </div>
      
      
      <section>
        <div className="custom-container roadmap">
          <h6 className="section-heading" data-aos="fade-up">
            FAQ
          </h6>
          <span data-aos="fade-up">
            We have provided major frequently Asked Questions (FAQ) by below, strongly recommend to join our communities of social network for more detials.
          </span>
          <div className="qna" data-aos="fade-up">
            <div
              className="panel-group"
              id="accordion"
              role="tablist"
              aria-multiselectable="true"
            >
              {accordions.map((item) => (
                <div key={item.id} className="panel panel-default">
                  <div className="panel-heading" role="tab">
                    <h4 className="panel-title">
                      <a
                        className={activeIndex === item.id ? "" : "collapsed"}
                        role="button"
                        onClick={() => toggleAccordion(item.id)}
                        aria-expanded={activeIndex === item.id}
                      >
                        {item.title}
                      </a>
                    </h4>
                  </div>
                  <div
                    className={`panel-collapse collapse ${
                      activeIndex === item.id ? "show" : ""
                    }`}
                    role="tabpanel"
                  >
                    <div className="panel-body">
                      <p>{item.body}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default Home;
